(function () {
    'use strict';

    angular
        .module('expedientesUriarteApp', [
            'ngStorage',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'ui.tree',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'ncy-angular-breadcrumb',
            'ui.tree',
            'ngFileUpload',
            'ngMessages',
            'ngMaterial',
            'ngMaterialSidemenu',
            'angular-click-outside',
            'ngCsv',
            'chart.js',
            'toastr'
        ])
        .run(run);

    run.$inject = ['stateHandler'];

    function run(stateHandler) {
        stateHandler.initialize();
    }
})();
